module.exports = __webpack_public_path__ + "static/img/delete.5698f1ac.svg";